export const CIRCLE_USER_GEOMETRY = 'Circle';
export const AREA_USER_GEOMETRY = 'Area';
export const LINE_USER_GEOMETRY = 'Line';
export const POINT_USER_GEOMETRY = 'Point';